// client/src/components/scheduling/DayPicker.js

/**
 * Day picker component for selecting days of the week
 * Used in recurring availability forms
 */
export default function DayPicker({ selectedDays, onChange }) {
  const days = [
    { key: 'MO', label: 'Mon' },
    { key: 'TU', label: 'Tue' },
    { key: 'WE', label: 'Wed' },
    { key: 'TH', label: 'Thu' },
    { key: 'FR', label: 'Fri' },
    { key: 'SA', label: 'Sat' },
    { key: 'SU', label: 'Sun' },
  ]

  const toggleDay = (dayKey) => {
    if (selectedDays.includes(dayKey)) {
      onChange(selectedDays.filter((d) => d !== dayKey))
    } else {
      onChange([...selectedDays, dayKey])
    }
  }

  return (
    <div className="day-picker" role="group" aria-label="Select days">
      {days.map((day) => (
        <button
          key={day.key}
          type="button"
          className={`day-btn ${selectedDays.includes(day.key) ? 'selected' : ''}`}
          onClick={() => toggleDay(day.key)}
          aria-pressed={selectedDays.includes(day.key)}
        >
          {day.label}
        </button>
      ))}
    </div>
  )
}
